import React from 'react';
import { Routes, Route } from 'react-router-dom';
import News from '../layout/News';
import NewsItemPage from '../layout/NewsItemPage';

function NewsRoute() {
	return (
		<Routes>
			<Route index element={<News />} />
			<Route path=":id" element={<NewsItemPage />} />
			<Route path="*" element={<News />} />
		</Routes>
	);
}

export default NewsRoute;
